export class Attachment {
  id: string; 
  attachmentName: string;
  emailItemId: string;
  attachmentContent: any[];
}
export class Email {
  id: string;
  sentOn?: any;
  receivedOn?: any;
  fromName: string;
  fromEmail: string;
  to: string;
  subject: string;
  htmlContent: string;
  attachments: Attachment[];
  folderName?: any;
  messageNumber: number;
  pagesize: number;
  offset: number;
}
export class OrganisationalEmail {
  emails : Email[];
  entityId : number;
  password: string;
}



// WEBPACK FOOTER //
// ./src/app/entities/emails/emails-model.ts